var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 15,
  viewBox: "0 0 20 15"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M.001 14.069H19.99V.01H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "$",
  fill: "#CACACA",
  d: "M7.93 9.633V4.017l5.4 2.818zm11.86-6.589s-.195-1.377-.795-1.984c-.76-.796-1.612-.8-2.002-.847C14.194.011 9.999.011 9.999.011h-.01s-4.195 0-6.992.202C2.607.26 1.755.264.994 1.06.394 1.667.2 3.044.2 3.044S0 4.662 0 6.28v1.517c0 1.617.2 3.235.2 3.235s.195 1.377.794 1.984c.76.796 1.76.77 2.204.854 1.6.154 6.796.201 6.796.201s4.2-.006 6.998-.209c.39-.046 1.242-.05 2.002-.846.6-.607.795-1.984.795-1.984s.2-1.618.2-3.235V6.279c0-1.617-.2-3.235-.2-3.235z"
}))));
export default SvgYoutube;